const verificarFomatoJsonBaseDatos = (data) => {
  try {
    if (data.reqCondicionesGral) {
      JSON.parse(data.reqCondicionesGral);
    }
    if (data.leyenda) {
      JSON.parse(data.leyenda);
    }
    if (data.reqPrequirurgico) {
      JSON.parse(data.reqPrequirurgico);
    }
  } catch (error) {
    alert(
      "Formato Json inválido en Base de Datos. Comuníquese con el Administrador de Sistema"
    );
  }
};

export const parserJsonTemplate = (data) => {
  // verificarFomatoJsonBaseDatos(data);
  console.log("ver entrada", data)
  const dataTurno = {
    nombre: data.solicitante.nombreCompleto || "No especificado",
    dni: data.solicitante.dni || "No especificado",
    domicilio: data.solicitante.domicilio || "No especificado",
    lugar: data.turno.lugar || "No especificado",
    servicio: data.turno.servicio || "No especificado",
    nroTurno: data.turno.nroTurno || "No especificado",
    fecha: data.turno.fecha || "No especificado",
    hora: data.turno.hora || "No especificado",
    padron: data.turno.padron || "No especificado",
    tipoPadron: data.turno.tipoPadron || "No especificado",
    leyenda: data.leyenda || "No especificado",
    conSuscriptor: data.solicitante.conSuscriptor || "No especificado",
    email: data.solicitante.email || "No especificado",
    telFijo: data.solicitante.telFijo || "No especificado",
    telMovil: data.solicitante.telMovil,
  };

  console.log("Ver salida", dataTurno)

  return dataTurno;
};
